import Text from "common/Typography/Text";
import CustomInputNumber from "common/Inputs/CustomInputNumber";
import Title from "common/Typography/Title";
import Space from "antd/es/space";
import { useContext, useEffect } from "react";
import { ExchangesMetadataContext } from "@shared/features/common/ExchangesMetadata.context";
import { getMinAndMaxPrices } from "@shared/features/tradingTerminal/common/utils";
import { CreateOrderGeneralInfo, LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";

interface LimitPriceInputProps {
  handlePriceChange: (value: string) => void;
  limitPrice?: string;
  setError: (error: boolean) => void;
  error?: boolean;
  pricePrecision?: number;
  exchange?: string;
  generalInfo?: CreateOrderGeneralInfo;
}

const LimitPriceInput = ({
  handlePriceChange,
  limitPrice,
  setError,
  error,
  pricePrecision = 0,
  exchange,
  generalInfo,
}: LimitPriceInputProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const { getExchangePriceFactorLimits } = useContext(
    ExchangesMetadataContext
  )!;
  const currentPrice = generalInfo?.data.current_price || 0;
  const priceFactorLimits = getExchangePriceFactorLimits(exchange);

  const { min: minPrice, max: maxPrice } = getMinAndMaxPrices(
    currentPrice,
    pricePrecision,
    priceFactorLimits
  );

  useEffect(() => {
    if (
      !limitPrice ||
      Number(limitPrice) > maxPrice ||
      Number(limitPrice) < minPrice
    ) {
      setError(true);
    } else {
      setError(false);
    }
  }, [limitPrice, minPrice, maxPrice]);

  return (
    <Space size={4} orientation="vertical" style={{ width: "100%" }}>
      <Title type="secondary" level={4}>
        {t("create_order.limit_price")}
      </Title>
      <CustomInputNumber
        name={"limit_price"}
        value={limitPrice}
        onChange={handlePriceChange}
        precision={pricePrecision}
        stringMode={true}
      />
      {error && (
        <Text as="div" type="danger">
          {t("create_order.price_min_max", { minPrice, maxPrice })}
        </Text>
      )}
    </Space>
  );
};

export default LimitPriceInput;
